import { asmx } from './http'
import { formatDateOnly, serializeDateOnly } from '../utils/date-time'

const normalizeTemplate = value => {
  if (!value) return value
  value.effective_start_date = formatDateOnly(value.effective_start_date, value.effective_start_date)
  value.effective_end_date = formatDateOnly(value.effective_end_date, value.effective_end_date)
  return value
}

const removeAsmxMetadata = value => {
  if (Array.isArray(value)) return value.map(removeAsmxMetadata)
  if (!value || typeof value !== 'object') return value
  return Object.keys(value).reduce((result, key) => {
    if (key !== '__type') result[key] = removeAsmxMetadata(value[key])
    return result
  }, {})
}

const serializeTemplate = request => {
  const payload = removeAsmxMetadata(JSON.parse(JSON.stringify(request || {})))
  delete payload.total_weight
  payload.effective_start_date = serializeDateOnly(payload.effective_start_date)
  payload.effective_end_date = serializeDateOnly(payload.effective_end_date)
  return payload
}

export const assessmentApi = {
  getTemplates: status => asmx('AssessmentService', 'GetAssessmentTemplates', { status: status || null }, 'request').then(items => (items || []).map(normalizeTemplate)),
  getTemplateDetail: templateSjid => asmx('AssessmentService', 'GetAssessmentTemplateDetail', { template_sjid: templateSjid }, 'request').then(normalizeTemplate),
  saveTemplate: request => asmx('AssessmentService', 'SaveAssessmentTemplate', serializeTemplate(request), 'request'),
  getPeriods: (templateSjid, year) => asmx('AssessmentService', 'GetAssessmentPeriods', { template_sjid: templateSjid || null, period_year: year || 0 }, 'request'),
  createPeriod: request => asmx('AssessmentService', 'CreateAssessmentPeriod', request, 'request'),
  recalculatePeriod: periodSjid => asmx('AssessmentService', 'RecalculateAssessmentPeriod', { period_sjid: periodSjid }, 'request'),
  publishPeriod: periodSjid => asmx('AssessmentService', 'PublishAssessmentPeriod', { period_sjid: periodSjid }, 'request'),
  lockPeriod: periodSjid => asmx('AssessmentService', 'LockAssessmentPeriod', { period_sjid: periodSjid }, 'request'),
  getResultList: request => asmx('AssessmentService', 'GetAssessmentResultList', request, 'request'),
  getUserResultDetail: userResultSjid => asmx('AssessmentService', 'GetAssessmentUserDetail', { user_result_sjid: userResultSjid }, 'request'),
  generateAiInterpretation: userResultSjid => asmx('AssessmentService', 'GenerateAssessmentInterpretation', { user_result_sjid: userResultSjid }, 'request')
}
